import { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/home/HeroSection';
import TrustPhilosophySection from '../components/home/TrustPhilosophySection';
import StaffSection from '../components/home/StaffSection';
import { DoctorSection, ServicesSection, CancerSection } from '../components/home/ServicesSections';
import AwardsSection from '../components/home/AwardsSection';
import ReviewsSection from '../components/home/ReviewsSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import { testimonials } from '../data/homeData';

const Home = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 3) % testimonials.length);
    }, 8000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="pb-20 md:pb-0" data-testid="home-page">
      <SEO
        title="Men's Urology Clinic Melbourne FL"
        description="Havkin Urology provides confidential men's urology care in Melbourne, Florida. Expert treatment for ED, low testosterone, BPH, Peyronie's disease & vasectomy. Call (321) 500-4545."
        keywords="urologist Melbourne FL, men's health clinic, erectile dysfunction treatment, low testosterone, BPH, vasectomy, Peyronie's disease, Dr. Havkin"
        canonical="/"
      />
      <HeroSection />
      <TrustPhilosophySection />
      <StaffSection />
      <DoctorSection />
      <ServicesSection />
      <CancerSection />
      <AwardsSection />
      <ReviewsSection currentTestimonial={currentTestimonial} />
      <HowItWorksSection />
    </div>
  );
};

export default Home;
